import { UserChatStatus } from '@/components/chat/_domain/modules/user-chat-status-service/user-chat-status-service-interface';
enum MessageType {
  User = 'User',
  UserEntered = 'UserEntered',
  UserLeft = 'UserLeft',
  ChatFreeze = 'ChatFreeze',
  Jackpot = 'JackpotWinner',
  AlertWord = 'AlertWord'
}

class ChatMessageModel {
  private messageTypeValue: MessageType;
  public cssClass: string;
  public chatPrize: boolean;
  public notEligibleForPromo: boolean;
    public notEligibleForChatPrize: boolean;
  public newMember: boolean;
  public troubleMaker: boolean;
  public readonly displayedUsername: string;
  private isHighlightedValue: boolean = false;

  constructor(messageType: MessageType, public id?: number, public readonly username?: string, public messageText?: string, public timestamp?: string, public userChatStatus?: UserChatStatus, public usernameStylingClasses?: string, public messagePrefix?: string, public messageColour?: string) {
    this.messageType = messageType;
    this.displayedUsername = this.determineDisplayedUsername(username);
  }

  public get messageType(): MessageType {
    return this.messageTypeValue;
  }

  public set messageType(value: MessageType) {
    if (value !== this.messageTypeValue) {
      this.messageTypeValue = value;
      this.cssClass = this.determineCssClass();
    }
  }

  public get isHighlighted(): boolean {
    return this.isHighlightedValue;
  }

  public set isHighlighted(value: boolean) {
    if (value !== this.isHighlightedValue) {
      this.isHighlightedValue = value;
      this.cssClass = this.determineCssClass();
    }
  }

  private determineCssClass() {
    let cssClass = '';

    if (this.messageType === MessageType.UserEntered || this.messageType === MessageType.UserLeft) {
      cssClass = 'chat-user-entered-or-left';
    }
    else if (this.messageType === MessageType.ChatFreeze) {
      cssClass = 'chat-freeze';
    }
    else if (this.messageType === MessageType.Jackpot) {
      cssClass = 'jackpot-winner';
    }
    else if (this.messageType === MessageType.AlertWord) {
      cssClass = 'alert-word';
    }

    if (this.isHighlighted) {
      cssClass = `${cssClass} highlight`.trim();
    }

    return cssClass;
  }

  private determineDisplayedUsername(username: string): string {
    if (this.userChatStatus === UserChatStatus.TeamLeader) {
      const cmPrefix = username.substr(0, 2);
      return username.replace(`${cmPrefix}-`, `${cmPrefix}-TL-`);
    }
    if (this.userChatStatus === UserChatStatus.ShiftLeader) {
      const cmPrefix = username.substr(0, 2);
      return username.replace(`${cmPrefix}-`, `${cmPrefix}-SL-`);
    }
    if (this.usernameStylingClasses) {
      if (this.usernameStylingClasses.includes('bling-user')) {
        username = username + '*';
      }
      if (this.usernameStylingClasses.includes('notEligibleForPromo-user')) {
        username = username + '^';
      }
      if (this.usernameStylingClasses.includes('notEligibleForChatPrize-user')){
        username = username + '^';
      }
    }
    return username;
  }

  private getUserStatusUsernameStyling(username: string, stylingClasses: string): string {
    if (stylingClasses) {
      if (stylingClasses.includes('bling-user')) {
        username = username + '*';
      }
      if (stylingClasses.includes('notEligibleForPromo-user')) {
        username = username + '^';
      }
      if (stylingClasses.includes('notEligibleForChatPrize-user')) {
        username = username + '^';
      }
    }
    return username;
  }
}

export { MessageType, ChatMessageModel };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/chat/_domain/models/chat-message-model.ts